<!-- <div class="flex gap-2 p-2">
  <p-button class="flex" *ngIf="!this.authStore.isAuth()" label="Register" severity="primary" (click)="handleRegister()" />
  <p-button class="flex" *ngIf="!this.authStore.isAuth()" label="Login" severity="success" (click)="handleLoginAuth0()" />
  <p-button class="flex" *ngIf="this.authStore.isAuth()" label="Profile" severity="primary" (click)="handleLoginAuth0()" />
  <p-button class="flex" *ngIf="this.authStore.isAuth()" label="Get Auth" severity="help" (click)="getUserAuth0()" />
  <p-button class="flex" *ngIf="this.authStore.isAuth()" label="Logout" severity="danger" (click)="handleLogout()" />
</div> -->

<!-- <img
  src="https://raw.githubusercontent.com/appzstory/appzstory-ribbon/main/black_ribbon_top_left.png"
  alt="Black Ribbon Top Left"
  style="position: fixed; top: 0; left: 0; width: 80px; opacity: 0.9; z-index: 9999; pointer-events: none"
/> -->

<div class="tw:bg-surface-0 tw:px-12 tw:py-20 tw:md:px-20 tw:xl:px-80 tw:flex tw:items-center tw:justify-center tw:min-h-screen">
  <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-8 tw:min-h-140">
    <div class="flex gap-2">
      <img src="assets/icons/icon-main-logo.svg" alt="main-logo" width="250" height="250" />
    </div>
    <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:w-full">
      <h1 class="tw:text-4xl tw:font-bold tw:text-surface-900 tw:text-center tw:leading-tight">AIFLOW CRM</h1>
    </div>
    <!--    <p-button icon="pi pi-arrow-left" label="Back to Home" [text]="true"></p-button>-->

    @if (!authFacade.isLoggedIn()) {
      <a class="btn cursor-pointer text-base sm:text-xl" (click)="handleLogin()" (keyup.enter)="handleLogin()" tabindex="0">Login</a>
    } @else {
      <a
        class="btn cursor-pointer text-base sm:text-xl"
        (click)="handleRedirectToChooseCompany()"
        (keyup.enter)="handleRedirectToChooseCompany()"
        tabindex="0"
      >
        Profile
      </a>
    }
  </div>
</div>

<!-- ของเดิม -->
<!--<header class="header-sticky bg-white">-->
<!--  <ul class="main-header">-->
<!--    <div class="header-icon">-->
<!--      <img src="assets/icons/icon-main-logo.svg" alt="main-logo" width="40" height="60" />-->
<!--      <p class="mg-l-16">aiflow crm</p>-->
<!--    </div>-->

<!--    <ng-container *appHiddenProd>-->
<!--      <nav class="navbar-header align-items-center">-->
<!--        @for (item of landingMenuList; track $index) {-->
<!--          <a-->
<!--            href="{{ item.pathId }}"-->
<!--            [id]="currentMenu()"-->
<!--            (click)="onChangeLandingMunuId(item.pathId)"-->
<!--            [ngClass]="item.pathId === currentMenu() ? 'btn-secondary primary' : 'btn-inactive'"-->
<!--          >-->
<!--            {{ item.name }}-->
<!--          </a>-->
<!--        }-->
<!--      </nav>-->
<!--    </ng-container>-->

<!--    <div class="flex justify-content-center gap-2 md:gap-3">-->
<!--      @if (!authFacade.isLoggedIn()) {-->
<!--        <a-->
<!--          *appHiddenProdAndRc-->
<!--          class="btn cursor-pointer text-sm sm:text-base"-->
<!--          (click)="handleRegister()"-->
<!--          (keyup.enter)="handleRegister()"-->
<!--          tabindex="0"-->
<!--        >-->
<!--          Register-->
<!--        </a>-->
<!--        <a class="btn cursor-pointer text-sm sm:text-base" (click)="handleLogin()" (keyup.enter)="handleLogin()" tabindex="0">Login</a>-->
<!--      } @else {-->
<!--        <a-->
<!--          class="btn cursor-pointer text-sm sm:text-base"-->
<!--          (click)="handleRedirectToChooseCompany()"-->
<!--          (keyup.enter)="handleRedirectToChooseCompany()"-->
<!--          tabindex="0"-->
<!--        >-->
<!--          Profile-->
<!--        </a>-->
<!--      }-->
<!--    </div>-->
<!--  </ul>-->
<!--</header>-->

<!--<main>-->
<!--  <section id="#Home" class="scroll-sec">-->
<!--    <article class="item-center">-->
<!--      <img src="assets/images/img-landing-chat-example.png" alt="chat-example" />-->
<!--    </article>-->
<!--  </section>-->

<!--  <ng-container *appHiddenProd>-->
<!--    <section id="#section1" class="sec-banner scroll-sec">-->
<!--      <h1 class="h1-section">All your chats, one powerful platform</h1>-->

<!--      <article class="flex bg-primary align-items-center pd-banner img-banner">-->
<!--        <div>-->
<!--          <h1 class="fonts-h1 white pd-b-h">Curbitur non</h1>-->
<!--          <p class="fonts-sub white pd-b-btn">-->
<!--            Curabitur non accumsan nisl. Vivamus laoreet lacus non massa ultrices, in faucibus arcu interdum.-->
<!--          </p>-->
<!--        </div>-->
<!--        &lt;!&ndash; <a href="" class="btn-secondary">Register</a> &ndash;&gt;-->
<!--        <img class="img-banner" src="https://cdsassets.apple.com/live/SZLF0YNV/images/sp/111902_mbp14-silver2.png" alt="feature-1" />-->
<!--      </article>-->
<!--    </section>-->

<!--    <section id="#section2" class="col-12 sec-banner scroll-sec">-->
<!--      <article class="bg-blue flex justify-content-center align-items-center pd-banner">-->
<!--        <img src="assets/images/img-landing-feature-2.png" alt="feature-2" width="438" />-->
<!--      </article>-->

<!--      <article class="bg-grey flex justify-content-center align-items-center pd-banner">-->
<!--        <dl>-->
<!--          <dt>-->
<!--            <h1 class="pd-b-h fonts-h1">Curabitur non</h1>-->
<!--          </dt>-->
<!--          <p class="fonts-sub font-sub-color pd-b-h">-->
<!--            Curabitur non accumsan nisl.-->
<!--            <br />-->
<!--            Vivamus laoreet lacus non massa ultrices, in faucibus arcu-->
<!--            <br />-->
<!--            interdum.-->
<!--          </p>-->
<!--          <dd class="flex align-items-center mg-b-16">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          <dd class="flex align-items-center mg-b-16">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          <dd class="flex align-items-center mg-b-40">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          &lt;!&ndash; <a href="#" class="btn-third flex align-items-center flex-col">Register</a> &ndash;&gt;-->
<!--        </dl>-->
<!--      </article>-->

<!--      <article id="#section3" class="bg-grey flex justify-content-center align-items-center pd-banner scroll-sec">-->
<!--        <dl>-->
<!--          <dt>-->
<!--            <h1 class="pd-b-h fonts-h1">Curabitur non</h1>-->
<!--          </dt>-->
<!--          <p class="fonts-sub font-sub-color pd-b-h">-->
<!--            Curabitur non accumsan nisl.-->
<!--            <br />-->
<!--            Vivamus laoreet lacus non massa ultrices, in faucibus arcu-->
<!--            <br />-->
<!--            interdum.-->
<!--          </p>-->
<!--          <dd class="flex align-items-center mg-b-16">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          <dd class="flex align-items-center mg-b-16">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          <dd class="flex align-items-center mg-b-40">-->
<!--            <p class="flex align-items-center">Curabitur non accumsan nisl.</p>-->
<!--          </dd>-->
<!--          &lt;!&ndash; <a href="#" class="btn-third flex align-items-center flex-col">Register</a> &ndash;&gt;-->
<!--        </dl>-->
<!--      </article>-->

<!--      <article class="bg-blue flex justify-content-center align-items-center pd-banner">-->
<!--        <img src="assets/images/img-landing-feature-3.png" alt="feature-3" width="346" style="border-radius: 20px" />-->
<!--      </article>-->
<!--    </section>-->

<!--    <article class="pd-p">-->
<!--      <h3 class="h3-section mg-b-24">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h3>-->
<!--      <p class="font-sub-color txt-center">-->
<!--        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ultricies est faucibus euismod hendrerit.-->
<!--      </p>-->
<!--    </article>-->
<!--  </ng-container>-->

<!--  <article class="pd-p">-->
<!--    <h3 class="h3-section mg-b-24">All your chats, one powerful platform</h3>-->
<!--    <p class="font-sub-color txt-center">Unlock the power of chat for increased efficiency and sales with AIFLOW CRM</p>-->
<!--  </article>-->

<!--  <section id="#section4" class="sec-banner scroll-sec">-->
<!--    <article class="col-3">-->
<!--      <div class="flex justify-content-center">-->
<!--        <img-->
<!--          class="border-round-lg"-->
<!--          src="assets/images/img-landing-feature-chat.png"-->
<!--          style="box-shadow: 0px 0px 8px 8px #eef7fe"-->
<!--          alt="landing-feature-chat"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="flex justify-content-center">-->
<!--        <img-->
<!--          class="border-round-lg"-->
<!--          src="assets/images/img-landing-feature-team.png"-->
<!--          style="box-shadow: 0px 0px 8px 8px #eef7fe"-->
<!--          alt="landing-feature-team"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="flex justify-content-center">-->
<!--        <img-->
<!--          class="border-round-lg"-->
<!--          src="assets/images/img-landing-feature-users.png"-->
<!--          style="box-shadow: 0px 0px 8px 8px #eef7fe"-->
<!--          alt="landing-feature-users"-->
<!--        />-->
<!--      </div>-->
<!--    </article>-->
<!--  </section>-->
<!--</main>-->

<!--<footer>-->
<!--  <article class="footer-banner bg-black">-->
<!--    <dl class="txt-center mg-b-16">-->
<!--      <dt class="flex justify-content-center mg-b-8">-->
<!--        <img class="icon-footer" src="assets/icons/icon-main-logo.svg" alt="main-logo" width="60px" />-->
<!--        <p class="flex align-items-center fonts-footer-h fonts-w-600 white mg-l-8">AIFLOW CRM</p>-->
<!--      </dt>-->
<!--      <dd class="fonts-footer-sub fonts-w-300 white line-height">-->
<!--        บริษัท จี-เทค แอนด์แอพพลิเคชัน จำกัด-->
<!--        <br />-->
<!--        47/404 ตำบลบ้านใหม่ อำเภอปากเกร็ด จังหวัดนนทบุรี 11120-->
<!--      </dd>-->
<!--    </dl>-->
<!--    &lt;!&ndash; <ul class="flex justify-content-center mg-b-16">-->
<!--      <li class="mg-l-16">-->
<!--        <a href="#">-->
<!--          <img class="icon-social" src="assets/icons/icon-landing-facebook.svg" alt="facebook" width="60px" />-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="mg-l-16">-->
<!--        <a href="#">-->
<!--          <img class="icon-social" src="assets/icons/icon-landing-line.svg" alt="line" width="60px" />-->
<!--        </a>-->
<!--      </li>-->
<!--      <li class="mg-l-16">-->
<!--        <a href="#">-->
<!--          <img class="icon-social" src="assets/icons/icon-landing-youtube.svg" alt="youtube" width="60px" />-->
<!--        </a>-->
<!--      </li>-->
<!--    </ul> &ndash;&gt;-->
<!--    <p class="txt-center fonts-ref white">-->
<!--      G-Tech and Application Ltd.-->
<!--      &lt;!&ndash; &copy; 2024 G-Tech & Application. All rights reserved. &ndash;&gt;-->
<!--    </p>-->
<!--  </article>-->
<!--</footer>-->
